import type { IUser } from '~/modules/main'

/**
 * Сохраняет dailyRewardText между ответами /user.
 * Бэк отдаёт текст только при первом запросе за календарный день;
 * последующие poll/route-change могут вернуть showDailyReward без текста.
 */
export const mergeUserResponse = (
  previous: IUser | null | undefined,
  next: IUser,
): IUser => {
  if (!next.showDailyReward) {
    return next
  }

  const nextText = next.dailyRewardText?.trim() ?? ''

  if (nextText.length > 0) {
    return next
  }

  const previousText = previous?.dailyRewardText?.trim() ?? ''

  if (previousText.length === 0) {
    return next
  }

  return {
    ...next,
    dailyRewardText: previousText,
  }
}
